import { IdentityAssignment } from '../IdentitiesGrid/types';
import { getAttributeDescription } from './constants';
import { IdentityAssignmentView, IdentityPermission } from './types';

function getPermissionAccess(attributeId: string): string {
  const suffix = attributeId.split(':')[1];
  return (suffix ?? attributeId).toUpperCase();
}

function getTabLabel(assignment: IdentityAssignment): string {
  if (assignment.name?.trim()) {
    return assignment.name.trim();
  }

  const roleId = assignment.roleId ?? assignment.roleIds?.[0];
  if (roleId) {
    return roleId;
  }

  return assignment.attributeIds[0] ?? 'Assignment';
}

function withUniqueTabLabels(
  views: IdentityAssignmentView[],
): IdentityAssignmentView[] {
  const seen = new Map<string, number>();

  return views.map(view => {
    const count = (seen.get(view.label) ?? 0) + 1;
    seen.set(view.label, count);

    if (count === 1) {
      return view;
    }

    return {
      ...view,
      label: `${view.label} ${count}`,
    };
  });
}

function toAssignmentView(
  assignment: IdentityAssignment,
): IdentityAssignmentView {
  const permissions: IdentityPermission[] = assignment.attributeIds.map(
    attributeId => ({
      permissionName: attributeId,
      description: getAttributeDescription(attributeId),
      access: getPermissionAccess(attributeId),
    }),
  );

  return {
    id: assignment.id,
    label: getTabLabel(assignment),
    permissions,
  };
}

export function toAssignmentViews(
  assignments: IdentityAssignment[],
): IdentityAssignmentView[] {
  return withUniqueTabLabels(assignments.map(toAssignmentView));
}
